import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TokenService } from 'src/app/shared/services/token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private _token: TokenService,
    private _notification: NotificationService,
    private _transloco: TranslocoService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Skip auth check for secure-admin path
    if (state.url.includes('secure-admin')) {
      return true;
    }

    if (this._token.getExp()) {
      if (this._token.isTokenExpired()) {
        this._notification.warning(
          this._transloco.translate('login.tokenExpired')
        );
        this.router.navigate(['/auth/login']);
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
